var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgImg = function SvgImg(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C705706C-0223-4EB0-9A08-39122078BE63") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Historia",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Botwise---Historia-zmian---Filtry-Expand-Stany",
    transform: "translate(-463.000000, -771.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(326.000000, 765.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(131.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "image-02-copy",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3043478,16 L0.695652174,16 C0.311453913,16 0,15.6885461 0,15.3043478 L0,0.695652174 C0,0.311453913 0.311453913,0 0.695652174,0 L15.3043478,0 C15.6885461,0 16,0.311453913 16,0.695652174 L16,15.3043478 C16,15.6885461 15.6885461,16 15.3043478,16 Z",
    id: "Path",
    fill: "#F5A623"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9303677,12.3551533 L10.5972827,7.14786398 C10.4713154,6.95071201 10.1949694,6.95071201 10.0690021,7.14786398 L7.32164685,11.4400523 L5.26044046,8.34367793 C5.13414654,8.1535678 4.86626317,8.1535678 4.73997258,8.34367793 L2.07350464,12.3492851 C1.89935762,12.6104627 2.05410275,13 2.33373858,13 L13.6662273,13 C13.9425468,13 14.0988084,12.6183938 13.9303677,12.3551533 Z",
    id: "Path",
    fill: "#FFFFFF"
  }))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgImg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/img.c641e8633a6c836e43f4f6fd974b88fe.svg";